import React, { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  AppBar,
  Toolbar,
  IconButton,
  Grid,
  InputAdornment,
  TablePagination
} from '@mui/material'
import {
  ArrowBack,
  Search,
  LockReset,
  Save,
  WhatsApp,
  Visibility,
  VisibilityOff,
  Autorenew
} from '@mui/icons-material'

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import api from '../../utils/axios'

const gerarSenhaAleatoria = () => {
  const caracteres = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
  let senha = '';
  for (let i = 0; i < 8; i++) {
    senha += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
  }
  return senha;
};

const AlterarSenhaProdutor = () => {
  const navigate = useNavigate()

  const { register: registerBusca, handleSubmit: handleSubmitBusca } = useForm({
    defaultValues: { nome: '', cpf: '' }
  })

  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: { senha: '' }
  })

  const [rows, setRows] = useState([]);
  const [produtorSelecionado, setProdutorSelecionado] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const formSenhaRef = useRef(null);

  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [loading, setLoading] = useState(false)

  const onSubmitBusca = async (data) => {
    setError('')
    setSuccess('')
    setProdutorSelecionado(null);
    setPage(0);
    setLoading(true)

    try {
      const response = await api.put('/produtor/list.php', {
        nome: data.nome,
        cpf: data.cpf
      })

      if (response.data.success) {
        setRows(response.data.produtores)
      } else {
        setError(response.data.message || 'Erro ao buscar produtores')
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao buscar produtores')
    } finally {
      setLoading(false)
    }
  }

  const handleSelecionar = (produtor) => {
    setError('')
    setSuccess('')
    setProdutorSelecionado(produtor);
    reset({ senha: '' });

    setTimeout(() => {
      formSenhaRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 0);
  }

  const handleGerarSenha = () => {
    reset({ senha: gerarSenhaAleatoria() });
    setShowPassword(true);
  }

  const onSubmit = async (data) => {
    if (!produtorSelecionado) {
      setError('Selecione um produtor para alterar a senha.');
      return;
    }

    setError('')
    setSuccess('')
    setLoading(true)

    try {
      const response = await api.put('/produtor/alterar_senha.php', {
        id: produtorSelecionado.id,
        senha: data.senha
      })

      if (response.data.success) {
        setSuccess('Senha alterada com sucesso!');
        setProdutorSelecionado({ ...produtorSelecionado, novaSenha: data.senha });
      } else {
        setError(response.data.message || 'Erro ao alterar a senha')
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao alterar a senha')
    } finally {
      setLoading(false)
    }
  }

  const handleSendWhatsApp = () => {
    if (!produtorSelecionado?.telefone) {
      setError('Produtor não possui telefone cadastrado.');
      return;
    }

    if (!produtorSelecionado?.novaSenha) {
      setError('Altere e salve a nova senha antes de enviar pelo WhatsApp.');
      return;
    }

    const cleanPhone = produtorSelecionado.telefone.replace(/\D/g, '');
    const message = `
Olá ${produtorSelecionado.nome}, sua senha de acesso ao sistema Merenda Escolar foi alterada.
CPF de acesso: ${produtorSelecionado.cpf}
Nova senha: ${produtorSelecionado.novaSenha}
Site: ${window.location.origin}
    `.trim();

    const waLink = `https://wa.me/55${cleanPhone}?text=${encodeURIComponent(message)}`;
    window.open(waLink, '_blank');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => navigate('/agroeconomia')}
            sx={{ mr: 2 }}
          >
            <ArrowBack />
          </IconButton>
          <LockReset sx={{ mr: 2 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Alterar Senha do Produtor
          </Typography>
        </Toolbar>
      </AppBar>

      <Container sx={{ py: 3 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <LockReset sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
            <Typography variant="h5" gutterBottom>
              Alterar Senha do Produtor
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
              {success}
            </Alert>
          )}

          <form className='admin-form' onSubmit={handleSubmitBusca(onSubmitBusca)}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Nome"
                  margin="normal"
                  {...registerBusca('nome')}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="CPF"
                  margin="normal"
                  {...registerBusca('cpf')}
                  placeholder="00000000000"
                />
              </Grid>

              <Grid item xs={12} md={4} sx={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  sx={{ mt: 3, backgroundColor: '#ccdb00' }}
                  startIcon={<Search />}
                  disabled={loading}
                >
                  Buscar
                </Button>
              </Grid>
            </Grid>
          </form>

          {rows.length > 0 && (
            <TableContainer component={Paper} sx={{ mt: 2 }}>
              <Table aria-label="produtores table">
                <TableHead>
                  <TableRow>
                    <TableCell>Nome</TableCell>
                    <TableCell align="right">CPF</TableCell>
                    <TableCell align="right">Telefone</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow
                        key={row.id}
                        hover
                        selected={produtorSelecionado?.id === row.id}
                        onClick={() => handleSelecionar(row)}
                        sx={{ cursor: 'pointer' }}
                      >
                        <TableCell component="th" scope="row">{row.nome}</TableCell>
                        <TableCell align="right">{row.cpf}</TableCell>
                        <TableCell align="right">{row.telefone}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>

              <TablePagination
                component="div"
                count={rows.length}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                rowsPerPageOptions={[5, 10, 25]}
                labelRowsPerPage="Linhas por página"
              />
            </TableContainer>
          )}

          {produtorSelecionado && (
            <Box ref={formSenhaRef} sx={{ mt: 4, scrollMarginTop: '80px' }}>
              <Typography variant="h6" gutterBottom>
                Produtor selecionado: {produtorSelecionado.nome}
              </Typography>

              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={3} alignItems="center">
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Nova senha"
                      type={showPassword ? 'text' : 'password'}
                      margin="normal"
                      {...register('senha', {
                        required: 'Informe a nova senha',
                        minLength: {
                          value: 5,
                          message: 'A senha deve ter no mínimo 5 caracteres'
                        }
                      })}
                      error={!!errors.senha}
                      helperText={errors.senha?.message}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Button
                      type="button"
                      variant="outlined"
                      size="large"
                      onClick={handleGerarSenha}
                      startIcon={<Autorenew />}
                      disabled={loading}
                    >
                      Gerar senha aleatória
                    </Button>
                  </Grid>

                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                      <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        startIcon={<Save />}
                        disabled={loading}
                      >
                        Salvar nova senha
                      </Button>

                      <Button
                        type="button"
                        variant="contained"
                        size="large"
                        sx={{ backgroundColor: '#25D366', '&:hover': { backgroundColor: '#128C7E' } }}
                        onClick={handleSendWhatsApp}
                        startIcon={<WhatsApp />}
                        disabled={loading || !produtorSelecionado?.novaSenha}
                      >
                        Enviar por WhatsApp
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </form>
            </Box>
          )}
        </Paper>
      </Container>
    </Box>
  )
}

export default AlterarSenhaProdutor
